import { i as isObjectLike, b as baseGetTag } from "./isObject-ec23ace2.js";
var symbolTag = "[object Symbol]";
function isSymbol(value) {
  return typeof value == "symbol" || isObjectLike(value) && baseGetTag(value) == symbolTag;
}
export {
  isSymbol as i
};
//# sourceMappingURL=isSymbol-c6f5cd95.js.map
